export default { sha: '0a179c777b5d2eaa700a6feb5e6c591e1a1a0ebc', buildNumber: 'undefined' }
